var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartagerGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7479697B-E8C2-455F-B546-E5D8834365B9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1",
    stroke: "none",
    strokeWidth: 5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1-hp-Copy",
    transform: "translate(-215.000000, -787.000000)",
    fill: "#9CA700",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MENU",
    transform: "translate(0.000000, 725.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(215.503894, 62.000025)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.332030199 3.16405092 5.3320302 3.16405092 5.3320302 4.82811132 0.332030199 4.82811132"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.332030199 12.1640509 5.3320302 12.1640509 5.3320302 13.8281113 0.332030199 13.8281113"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.332030199 21.1640509 5.3320302 21.1640509 5.3320302 22.8281113 0.332030199 22.8281113"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    transform: "translate(0.832030, 12.996081) rotate(90.000000) translate(-0.832030, -12.996081) ",
    points: "-9 12.1640509 10.6640604 12.1640509 10.6640604 13.8281113 -9 13.8281113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.996 0 L 6.832 0 C 6.169 0 5.533 0.263 5.064 0.732 C 4.595 1.201 4.332 1.837 4.332 2.5 L 4.332 5 C 4.332 6.381 5.451 7.5 6.832 7.5 L 16.996 7.5 C 18.377 7.5 19.496 6.381 19.496 5 L 19.496 2.5 C 19.496 1.119 18.377 0 16.996 0 L 10.996 0 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.996 9 L 6.832 9 C 6.169 9 5.533 9.263 5.064 9.732 C 4.595 10.201 4.332 10.837 4.332 11.5 L 4.332 14 C 4.332 15.381 5.451 16.5 6.832 16.5 L 16.996 16.5 C 18.377 16.5 19.496 15.381 19.496 14 L 19.496 11.5 C 19.496 10.119 18.377 9 16.996 9 L 10.996 9 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.996 18 L 6.832 18 C 6.169 18 5.533 18.263 5.064 18.732 C 4.595 19.201 4.332 19.837 4.332 20.5 L 4.332 23 C 4.332 24.381 5.451 25.5 6.832 25.5 L 16.996 25.5 C 18.377 25.5 19.496 24.381 19.496 23 L 19.496 20.5 C 19.496 19.119 18.377 18 16.996 18 L 10.996 18 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartagerGreen);
export default __webpack_public_path__ + "static/media/partager-green.dd673f388f9c92933b2e7e5204edeae4.svg";
export { ForwardRef as ReactComponent };